import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { View } from "./View";
import { useBalances } from "../../hooks";

export const Balances = () => {
  const navigate = useNavigate();

  const { refreshBalances } = useBalances();

  useEffect(() => refreshBalances(), []);

  const navigateToAddBankAccount = () => {
    navigate("/settings/accounts-and-currencies");
  };

  const navigateToNewTopUp = () => {
    navigate("/balances/top-ups/create");
  };

  return (
    <View
      navigateToAddBankAccount={navigateToAddBankAccount}
      navigateToNewTopUp={navigateToNewTopUp}
    />
  );
};
